import React, { useState } from "react";
import styled from "styled-components/native";
import { VDBText } from "..";
import { RadioButtonType } from "./types";
import { DefaultTheme } from "styled-components/native";

const RadioButton = ({
  label,
  checked,
  onPress,
  labelColor,
  styles,
  disabled,
  margin,
  hideRadioButton = false,
  buttonColor,
  description,
  hideLabel = false,
  testID,
  dataTestId,
  fillWidth = false,
}: RadioButtonType) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <ButtonOpacity
      onPress={onPress}
      disabled={disabled}
      margin={margin}
      fillWidth={fillWidth}
      testID={testID}
      data-testId={dataTestId}
      onHoverIn={() => {
        setIsHovered((hovered) => (hovered ? hovered : true));
      }}
      onHoverOut={() => {
        setIsHovered((hovered) => (hovered ? false : hovered));
      }}
    >
      {!hideRadioButton && (
        <ButtonView
          checked={checked}
          isHovered={isHovered}
          buttonColor={buttonColor}
          hideLabel={hideLabel}
        >
          {checked && <InnerCircle />}
        </ButtonView>
      )}
      {!hideLabel && (
        <TextContainer fillWidth={fillWidth}>
          <VDBText color={labelColor} type={styles}>
            {label}
          </VDBText>
          {description && (
            <VDBText color={labelColor} type={styles}>
              {description}
            </VDBText>
          )}
        </TextContainer>
      )}
    </ButtonOpacity>
  );
};

const ButtonOpacity = styled.Pressable<{
  margin?: string;
  fillWidth?: boolean;
}>`
  flex-direction: row;
  align-items: center;
  ${({ fillWidth }: { fillWidth?: boolean }) =>
    fillWidth
      ? `
    width: 100%;
    min-width: 0;
  `
      : ""}
  margin-top: ${({ margin }: { margin?: string }) => (margin ? margin : 12)}px;
  margin-bottom: ${({ margin }: { margin?: string }) =>
    margin ? margin : 12}px;
`;

const TextContainer = styled.View<{
  margin?: string;
  fillWidth?: boolean;
}>`
  ${({ fillWidth }: { fillWidth?: boolean }) =>
    fillWidth
      ? `
    flex: 1;
    flex-shrink: 1;
    min-width: 0;
  `
      : ""}
  flex-direction: column;
`;

const ButtonView = styled.View<{
  checked: boolean;
  isHovered: boolean;
  buttonColor?: string;
  hideLabel?: boolean;
}>`
  height: 20px;
  width: 20px;
  border-radius: 12px;
  border-width: ${({ checked }: { checked: boolean }) =>
    checked ? "3px" : "2px"};
  border-color: ${({
    theme,
    checked,
    buttonColor,
  }: {
    theme: DefaultTheme;
    checked: boolean;
    buttonColor?: string;
  }) => buttonColor || (checked ? theme["knob-bg-active"] : theme["knob-bor"])};
  background-color: ${({
    theme,
    checked,
    isHovered,
  }: {
    theme: DefaultTheme;
    checked: boolean;
    isHovered: boolean;
  }) =>
    checked
      ? theme["knob-cont"]
      : isHovered
      ? theme["knob-bg-hover"]
      : theme["knob-bg-static"]};
  align-items: center;
  justify-content: center;
  margin-right: ${({ hideLabel }: { hideLabel?: boolean }) =>
    hideLabel ? "0" : "8px"};
`;

const InnerCircle = styled.View`
  height: 8px;
  width: 8px;
  border-radius: 20px;
  border-color: ${({ theme }: { theme: DefaultTheme }) =>
    theme["knob-bg-active"]};
  border-width: 5px;
`;

export default RadioButton;
